import { WORLD_MAP_CONFIG } from '@/common/constants/mapConfig';

export const RUSSIA_CODE = 643;
export const CHINA_CODE = 156;
export const TAIWAN_CODE = 158;
export const HONG_KONG_CODE = 344;
export const MACAU_CODE = 446;

export const COUNTRY_NAME = {
  RUSSIA: 'russia',
  CHINA: 'china',
};

export const SPECIAL_TERRITORY_MAPPING = {
  [TAIWAN_CODE]: 223,
  [HONG_KONG_CODE]: 233,
  [MACAU_CODE]: 234,
};

export const REGION_TO_COUNTRY_MAPPING = {
  223: TAIWAN_CODE,
  233: HONG_KONG_CODE,
  234: MACAU_CODE,
};

export const MAP_CONFIG = {
  WORLD: WORLD_MAP_CONFIG,
  RUSSIA: {
    center: [66, 100],
    zoom: 2.5,
    maxZoom: 7,
    minZoom: 2,
  },
  CHINA: {
    center: [38, 105],
    zoom: 4,
    maxZoom: 7,
    minZoom: 3,
  },
  TAIWAN: {
    center: [23.5, 121],
    zoom: 5,
  },
  HONG_KONG: {
    center: [22.3, 114.2],
    zoom: 7,
  },
  MACAU: {
    center: [22.2, 113.5],
    zoom: 7,
  },
};

export const COLORS_LEGEND = [
  // '#E3E3E3',
  '#01A39D',
  '#019999',
  '#019497',
  '#018F95',
  '#018A93',
  '#018591',
  '#01808F',
  '#017B8D',
  '#01768B',
  '#017189',
  '#016C87',
  '#016785',
  '#016283',
  '#015D81',
  '#01587F',
  '#01537D',
  '#014E7B',
  '#014979',
  '#014477',
];

export const COLOR_DEFAULT = '#E3E3E3';
export const COLOR_MAX = '#013F75';
export const COLOR_BORDER = '#60a7ee';
export const GREENLAND_CODE = 304;
